/**
 * Nuxt writes ssrContext.url (path + query) into payload.path.
 * createCurrentLocation() then treats that string as the pathname when it
 * differs from window.location.pathname — so encoded query (%20, %28, …)
 * becomes the router URL and client hydration never finishes.
 *
 * Keep the browser URL (UTM / _kx) as-is. Only store the pathname in the
 * payload; the client reads the real query from window.location.search.
 */
export default defineNuxtPlugin({
  name: 'payload-path-query',
  enforce: 'pre',
  order: -25,
  setup (nuxtApp) {
    if (!import.meta.server) {
      return
    }

    const path = nuxtApp.payload.path
    if (typeof path === 'string' && path.includes('?')) {
      nuxtApp.payload.path = path.split('?')[0]
    }
  },
})
